import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DisplayLabel } from '../models/displayLabel';
import { ApiService } from './api.service';
import { PCacheable } from 'ts-cacheable';

@Injectable({
  providedIn: 'root',
})
export class SupportStatusTypeService {
  constructor(private readonly api: ApiService) {}

  @PCacheable()
  public async findAll(): Promise<DisplayLabel[]> {
    return this.api.get<DisplayLabel[]>(environment.api.beneficiaries + '/support-status-type');
  }
}
